//
// Module for the GL Transaction Setup index view
//
rs.module("fund/configuration/gltransactionsetup/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {
            var filter = $.js(jsSelectors.filter);
            var glAccountAssignmentSelect = filter.js(jsSelectors.glAccountAssignmentSelect);            
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);
            var addLink = $.js(jsSelectors.addLink);

            glAccountAssignmentSelect.on("change", function () {
                loadingSpinner.show();
                gridModule.update(
                    backendUrl,

                    { glAccountAssignmentKey: glAccountAssignmentSelect.val() },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        loadingSpinner.hide();

                        // Update the Add button url which includes the new GLAccountAssignmentKey
                        addLink.attr('href', gridUpdate.context.addUrl);
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);